// extracted by mini-css-extract-plugin
export default {"button":"VendorStoreMenu_button__Jx+wM","activeButton":"VendorStoreMenu_activeButton__T9SiK"};